import pipe from 'ramda/src/pipe'
import head from 'ramda/src/head'
import prop from 'ramda/src/prop'

export default pipe(
  head,
  prop('manufacturer')
)



// WEBPACK FOOTER //
// ./src/helpers/firstCamerasManufacturer.js